import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { isScrollingDisabled } from '../../ducks/ui.duck';

import { LayoutSingleColumn, NamedLink, Page } from '../../components';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterComponent from '../FooterContainer/FooterContainer';
import Overlay from './components/Overlay';
import SellerForm from './components/SellerForm';
import BuyerSignupForm from './components/BuyerSignupForm';
import SignupSection from './components/SignupSection';
import { submitBuyerData } from './BecomeASellerStaticPage.duck';

import css from './BecomeASellerStaticPage.module.css';

const BecomeASellerSections = props => {
  const { setIsShowSellerForm, setIsShowBuyerForm } = props;
  return (
    <>
      <section id={css["intro-top"]}>
        <div className={css.container}>
          <div className={css.content}>
            <h1>A marketplace like no other</h1>
            <h2>The global marketplace dedicated exclusively to handmade products,
                the artisans who make them, and the customers who love them.</h2>
          </div>
          <div className={css.imagegrid}>
            <div className={classNames(css.image, css.image1)}>
              <img
                src="/staticasset/images/become-a-seller/section1-image1.jpg"
                loading="lazy"
              />
            </div>
            <div className={css.imagegroup}>
              <div className={classNames(css.image, css.image2)}>
                <img
                  src="/staticasset/images/become-a-seller/section1-image2.jpg"
                  loading="lazy"
                />
              </div>
              <div className={classNames(css.image, css.image3)}>
                <img
                  src="/staticasset/images/become-a-seller/section1-image3.jpg"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id={css["intro-secondary"]}>
        <div className={css.container}>
          <div className={css.content}>
            <h2>
              The world wants to buy what you make
            </h2>
            <p>
              Customers across more than 100 nations are searching for unique, meaningful products made by artists and artisans who care about the quality of their work.
            </p>
            <p>
              <a
                href="#"
                onClick={e => {
                  e.preventDefault();
                  setIsShowSellerForm(true);
                }}
                className={classNames(css.button, 'button button-primary')}
                data-dialogtype="sellers"
              >Apply Today</a>
            </p>
          </div>
        </div>
      </section>


      <section id={css['customers-are-waiting']} className={css.blocktype1}>
        <div className={css.container}>
          <div className={classNames(css['banner-type2'], css.content)}>
            <div className={css.image}>
              <img
                  src="/staticasset/images/become-a-seller/section2-image1.jpg"
                  loading="lazy"
                  alt=""
                />
            </div>
            <div className={css.text}>
              <h3>
                Your customers are waiting. <span className={css.highlight}>Let us introduce you.</span>
              </h3>
              <p>
                For 20+ years, our parent company, NOVICA, has forged significant
                partnerships with National Geographic, the Smithsonian Folklife
                Festival, the International Trade Centre (WTO and United Nations)
                and other key collaborators, developing a customer base of
                millions of deeply loyal individuals who appreciate handmade art.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id={css['new-world-for-artisans']} className={css.blocktype2}>
        <div className={css.container}>
          <div className={classNames(css['banner-type2'], css.content)}>            
            <div className={css.text}>
              <h3>
                We're building a <span className={css.highlight}>whole new world</span> for artisans.
              </h3>
              <p>
                Because a better world for artisans is a better world for all.
              </p>
              <h3>
                Where artisans are in the <span className={css.highlight}>driver's seat</span>.
              </h3>
              <p>
                Recognition, accountability, and transparency are our core values.
              </p>
            </div>
            <div className={css.image}>
              <img
                src="/staticasset/images/become-a-seller/section3-image1b.jpg"
                loading="lazy"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <section id={css['eveything-is-handmade']} className={css.blocktype1}>
        <div className={css.container}>          
          <div className={css.content}>
            <div className={css.text}>
              <h2>
                Everything is <span>handmade.</span>
              </h2>
              <p>
                No imitations, mass produced knock-offs, or cookie-cutter
                products.
              </p>
            </div>
            <div className={css.imageblock}>
              <div className={css.imagegroup}>
                <div className={classNames(css.image, css.image1)}>
                  <img
                    src="/staticasset/images/become-a-seller/section4-image1.jpg"
                    loading="lazy"
                    alt=""
                  />
                </div>
                <div className={classNames(css.image, css.image2)}>
                  <img
                    src="/staticasset/images/become-a-seller/section4-image3.jpg"
                    loading="lazy"
                    alt=""
                  />
                </div>
              </div>              
              <div className={classNames(css.image, css.image3)}>
                <img
                  src="/staticasset/images/become-a-seller/section4-image2.jpg"
                  loading="lazy"
                  alt=""
                />
              </div>
            </div>
            <div className={css.text}>
              <h3>
                And absolutely NO hidden fees.
              </h3>
              <p>Transparent pricing and lots of seller benefits.</p>
            </div>
          </div>
        </div>
      </section>

      <section id={css['more-than-a-marketplace']} className={css.blocktype2}>
        <div className={css.container}>
          <div className={classNames(css.content, css.alightcenter)}>
            <h2>
              More than a marketplace. A movement.
            </h2>
            <p>
              In almost every store. In almost every refrigerator, restaurant,
              closet, winery, gift shop, corner grocery. There it is:
              Artisan-made. Boldly on the label.
            </p>
          </div>          
        </div>
      </section>      

      <section id={css['artisan-community']} className={css.blocktype1}>
        <div className={css.container}>
          <div className={css.content}>
            <div className={css.text}>
              <h3>
                Why? Because people <span className={css.highlight}>really do care.</span>
              </h3>
              <p>
                In a world increasingly anonymous and consolidated, we crave meaning and authenticity.
              </p>
            </div>
            <div className={css.text}>
              <h3>
                <span className={css.block}>Welcome Home.</span>{' '}
                Not so long ago, <span className={css.highlight}>most of us were artisans.</span>
              </h3>
              <p>
                Now, today's creators tether us to that forgotten past.{' '}
                <em>Welcome home</em>, we might start saying to each other.{' '}
                <em>Welcome home.</em>
              </p>
            </div>
            <div className={css.text}>
              <h3>
                Quality, culture, heritage, authenticity, <span className={css.highlight}>fair trade.</span>
              </h3>
              <p>A community ready to live by a different set of values.</p>
            </div>
          </div>
        </div>
      </section>

      <section id={css['movement-of-we']}>
        <div className={css.container}>
          <div className={css.image}>
            <img 
              src="/staticasset/images/become-a-seller/section7-image1.jpg" 
              alt="" 
              loading="lazy" 
            />
          </div>
          <div className={css.content}>
            <h2>
              Handmade is a movement of We.
            </h2>
            <p>
              It belongs to us all. It is core to our beings. Fundamental in every realm of our lives.
            </p>
          </div>          
        </div>
      </section>

      {/*<section
        id={css['why-handmade']}
        className={`${css.container} ${css.full}`}
      >
        <div className={`${css.contentblock} ${css.block3} ${css.spaceright}`}>
          <div className={css.text}>
            <h4>
              Why? Because people{' '}
              <span className={css['c-highlight3']}>really do care.</span>
            </h4>
            <p>
              In a world increasingly anonymous and consolidated, we crave
              meaning and authenticity.
            </p>
          </div>
          <div className={css.imageblock}>
            <div className={`${css.image} ${css.image1}`}>
              <img
                src="/staticasset/images/become-a-seller/section5-image1b.jpg"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>*/}

      <section id={css['happening-now']} className={css.blocktype1}>
        <div className={css.container}>
          <div className={classNames(css['banner-type2'], css.content)}>
            <div className={css.text}>
              <h3>
                Once in a generation, an industry experiences a massive shift
              </h3>
              <p>
                that disrupts the current landscape and creates a better path.
              </p>
              <h3>
                It's happening. <span className={css.highlight}>Now.</span>
              </h3>
            </div>
            <div className={css.imageblock}>
              <div className={css['imagerow']}>
                <div className={css.image}>
                  <img
                    src="/staticasset/images/become-a-seller/section8-image1b.jpg"
                    loading="lazy"
                    alt=""
                  />
                </div>
                <div className={css.image}>
                  <img
                    src="/staticasset/images/become-a-seller/section8-image3.jpg"
                    loading="lazy"
                    alt=""
                  />
                </div>
                <div className={css.image}>
                  <img
                    src="/staticasset/images/become-a-seller/section8-image4.jpg"
                    loading="lazy"
                    alt=""
                  />
                </div>
              </div>
              <div className={css['imagerow']}>
                <div className={css.image}>
                  <img
                    src="/staticasset/images/become-a-seller/section8-image5.jpg"
                    loading="lazy"
                    alt=""
                  />
                </div>
                <div className={css.image}>
                  <img
                    src="/staticasset/images/become-a-seller/section8-image2b.jpg"
                    loading="lazy"
                    alt=""
                  />
                </div>
                <div className={css.image}>
                  <img
                    src="/staticasset/images/become-a-seller/section8-image6.jpg"
                    loading="lazy"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id={css['is-handmade-right-place']} className={css.blocktype2}>
        <div className={css.container}>
          <div className={classNames(css['banner-type2'], css.content)}>
            <div className={css.image}>
              <img
                src="/staticasset/images/become-a-seller/section9-image1b.jpg"
                loading="lazy"
              />
            </div>           
            <div className={css.text}>
              <h3>
                Sellers, is <span className={css.highlight}>Handmade.com</span> the
                right place for you?
              </h3>
              <p>
                If you're someone who creates and/or sells handmade products and
                commits to our Ethically Made standards, then we say:{' '}
                <em>Welcome Home!</em>
              </p>
            </div>            
          </div>
        </div>
      </section>

      <section id={css['handmade-qualification']} className={css.blocktype2}>
        <div className={css.container}>
          <div className={classNames(css['banner-type2'], css.content)}>
            <div className={css.text}>
              <h3>
                What qualifies as{' '}<span className={css.highlight}>handmade?</span>
              </h3>
              <p>
                Goods created by hand or goods significantly altered or finished
                by hand. Non-handmade products may qualify if they have been
                repurposed with notable handmade alterations or embellishments.
              </p>
            </div>
            <div className={css.imageblock}>
              <div className={classNames(css.image, css.image1)}>
                <img
                  src="/staticasset/images/become-a-seller/section10-image1.jpg"
                  loading="lazy"
                  alt=""
                />
              </div>
              <div className={css.imagegroup}>
                <div className={classNames(css.image, css.image2)}>
                  <img
                    src="/staticasset/images/become-a-seller/section10-image2.jpg"
                    loading="lazy"
                    alt=""
                  />
                </div>
                <div className={classNames(css.image, css.image3)}>
                  <img
                    src="/staticasset/images/become-a-seller/section10-image3.jpg"
                    loading="lazy"
                    alt=""
                  />
                </div>
              </div>
            </div>            
          </div>
        </div>
      </section>

      <section id={css['about-novica']} className={css.blocktype1}>
        <div className={css.container}>
          <div className={css.content}>
            <div className={css.text}>
              <h3>
                Born of <span className={css.highlight}>mission</span>,{' '}
                <span className={css.highlight}>quality</span> and{' '}
                <span className={css.highlight}>authenticity.</span>
              </h3>
              <p>
                NOVICA, a leader in the handmade movement, has a long-established
                global infrastructure in place with millions of impassioned
                customers in 100 nations around the globe.
              </p>
              <p id={css['logo-novica']}>
                <img
                  src="/staticasset/images/landing/full-small-2019.png"
                  alt="NOVICA.com"
                  width="275"
                  height="85"
                />
              </p>
            </div>
            <div className={css.reviews}>
              <div className={css.review}>
                <span className={css['review-stars']}>
                  <img src="https://handmade.com/media-library/image.png?id=56453041" width="20" className="rating-star" alt="" />
                  <img src="https://handmade.com/media-library/image.png?id=56453041" width="20" className="rating-star" alt="" />
                  <img src="https://handmade.com/media-library/image.png?id=56453041" width="20" className="rating-star" alt="" />
                  <img src="https://handmade.com/media-library/image.png?id=56453041" width="20" className="rating-star" alt="" />
                  <img src="https://handmade.com/media-library/image.png?id=56453041" width="20" className="rating-star" alt="" />
                </span>
                <div className={css['review-detail']}>
                  <p>
                    Thanks for providing people with a way to truly support
                    artists and artisans throughout the world. Being an artist
                    myself, I know firsthand the importance of having one's work
                    fully appreciated and fairly paid for. Bravo to each artisan
                    for their beautiful work. They make me travel around the world
                    in my own home and love it!
                  </p>
                </div>
                <p className={css['review-reviewer']}>Veronique Henry</p>
              </div>
              <div className={css.review}>
                <div className={css['review-detail']}>
                  <p>
                    Thank you for the confidence and perseverance in being part of
                    our growth process. You have shown us a new market with many
                    opportunities to continue growing and showing the traditions
                    that define us.
                  </p>
                </div>
                <p className={css['review-reviewer']}>
                  Delfina Ruiz<span>weaver</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id={css["join-us-handmade-movement"]}>
        <div className={css.container}>
          <div className={css.content}>
            <h2>
              Join the handmade movement today
            </h2>
            <p>
              <a
                href="#"
                onClick={e => {
                  e.preventDefault();
                  setIsShowSellerForm(true);
                }}
                className={classNames(css.button, 'button button-primary')}
                data-dialogtype="sellers"
              >Apply Today</a>
            </p>
            {/* <div className={css['join-us-module']}>
              <div className={classNames(css.panel, css.sellers)}>
                <h3>Sellers</h3>
                <p>Join the waitlist to apply for a storefront.</p>
                <p>
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      setIsShowSellerForm(true);
                    }}
                    className={classNames(css.button, 'button button-primary')}
                    data-dialogtype="sellers"
                  >Apply Today</a>
                </p>
              </div>
              <div className={classNames(css.panel, css.buyers)}>
                <h3>Buyers</h3>
                <p>Join today to advocate for a handmade future.</p>
                <p>
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      setIsShowBuyerForm(true);
                    }}
                    className={classNames(css.button, 'button button-primary')}
                    data-dialogtype="buyers"
                  >
                    Join today
                  </a>
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

const BecomeASellerStaticPage = () => {
  // const [isOpenMobileMenu, setIsOpenMobileMenu] = useState(false);
  const [isOpenGatewayDialog, setIsOpenGatewayDialog] = useState(false);
  const [isShowSellerForm, setIsShowSellerForm] = useState(false);
  const [isShowBuyerForm, setIsShowBuyerForm] = useState(false);

  const scrollingDisabled = useSelector(state => isScrollingDisabled(state));

  useEffect(() => {
    if (!isOpenGatewayDialog) {
      setIsShowSellerForm(false);
      setIsShowBuyerForm(false);
    }
  }, [isOpenGatewayDialog]);

  useEffect(() => {
    if (isShowSellerForm || isShowBuyerForm) {
      setIsOpenGatewayDialog(true);
    }
  }, [isShowSellerForm, isShowBuyerForm]);

  const intl = useIntl();

  const dispatch = useDispatch();
  const onSubmitBuyerData = values => dispatch(submitBuyerData(values));

  const handleSubmitBuyerData = values => {
    return onSubmitBuyerData(values);
  };

  const shouldOpenDialog = isOpenGatewayDialog;

  const title = intl.formatMessage({ id: 'BecomeASellerStaticPage.title' });

  return (
    <Page
      className={css.staticPageBase}
      title={title}
      scrollingDisabled={shouldOpenDialog || scrollingDisabled}
      referrer="origin"
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<FooterComponent />}
      >
        <div
          className={classNames(css.handmadecontent, {
            [css['dialog-open']]: shouldOpenDialog,
          })}
        >
          <div id={css['main-canvas']}>
            <div id={css['main-content']}>
              <BecomeASellerSections
                setIsShowSellerForm={setIsShowSellerForm}
                setIsShowBuyerForm={setIsShowBuyerForm}
              />
            </div>
          </div>
          <Overlay
            isOpenSellerForm={isShowSellerForm}
            onOpenGatewayDialog={setIsOpenGatewayDialog}
          >
            {isShowSellerForm || isShowBuyerForm ? (
              isShowSellerForm ? (
                <SellerForm />
              ) : (
                <BuyerSignupForm onSubmit={handleSubmitBuyerData} />
              )
            ) : (
              isOpenGatewayDialog && (
                <SignupSection
                  onOpenSellerForm={setIsShowSellerForm}
                  onOpenBuyerForm={setIsShowBuyerForm}
                />
              )
            )}
          </Overlay>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default BecomeASellerStaticPage;
